
<template>
  <!--动态管理-->
  <div>
    <x-tabula
      :apiOrigin="apiOrigin"
      ref="table"
      :dataSource="dataSource"
      rowKey="circle_id"
      :rowOptLen="4"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
      <template slot="opt_o" slot-scope="{row}">
        <a-tooltip>
          <p slot="title">{{row.content ? row.content : '此动态无文字描述'}}</p>
          <div class="dynamic-over-txt">{{row.content ? row.content : '此动态无文字描述'}}</div>
        </a-tooltip>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'dynamic',
  data () {
    return {
      apiOrigin: 'PHP',
      cascadeParam: {},
      searchList: [
        { props: ['keywords'], placeholder: '发布人、动态内容', options: [], inputType: 'input' },
        { props: ['circle_category_id'], placeholder: '发布栏目', options: [], inputType: 'cascader', changeOnSelect: true },
        { props: ['create_date'], placeholder: ['发布时间', '发布时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {
        keywords: undefined,
        circle_category_id: undefined,
        create_date: undefined
      },
      tableOptList: [],
      rowOptList: [
        { text: '查看', handle: record => this.toDetail(record), permin: ['neighbour:dynamic:detail'] }
      ],
      columns: [
        { title: '动态内容', dataIndex: 'content', align: 'left', width: '', scopedSlots: {customRender: 'o'} },
        { title: '发布栏目', dataIndex: 'circle_category_name', align: 'left', width: '' },
        { title: '发布人', dataIndex: 'nick_name', align: 'left', width: '' },
        { title: '发布时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/circle/circles',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        title: ''
      },
      deleteParam: {
        url: '',
        param: {pk_key: '', pk_val: ''},
        title: '',
        key: ''
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this._get({
        url: '/circle/circles/selectlist',
        params: {}
      }).then(({data}) => {
        this.searchList[1].options = data.columns;
      });
    },
    /** 切换页签 */
    tabsChange (e) {
    },
    /** 查看详情 */
    toDetail (row) {
      this.$router.push({
        name: 'dynamicDetail',
        query: { id: row.circle_id, ...this.breadParam(this) }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      return selectData;
    }
  }
};
</script>
